module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/performance-red.370d20b2.svg";